<template>
  <div>
    <section>
      <h4>因材施教 程度分班</h4>
      <p>
        高僑針對國小、國中課程，在每個孩子在進來就讀之前，先透過分班甄試，進一步瞭解孩子學習的程度到哪裡？再讓孩子進入目前最適合的班級就讀，當學習成效展現、成績有所提升，也可以升級進入更有挑戰的班級就讀！讓孩子永遠在最適合的學習環境成長，擁有挑戰的目標！
        每個不同程度的孩子，都有最適合的學習方式！在高僑，無論你是希望能顧好在校成績，希望能學習得更深入、更延伸，或是希望能超前學習，往更難的課程挑戰，高僑都能給你最適合的學習資源！
      </p>
    </section>
    <section>
      <h4>小班教學&amp;班導師制度</h4>
      <p>
        高僑一貫堅持小班教學，讓老師能把注意力集中在每個孩子身上，讓孩子的學習成效、上課秩序都有所提升。另外，我們在每一個班級都設置一位專屬的班導師，作為家長、老師、學生三者間的橋樑，也會透過課後電話訪問的方式關心學生們的學習狀況，也給予學生關懷，是輔助學生學習的重要角色。
      </p>
    </section>
    <section>
      <h4>專業課後輔導</h4>
      <p>
        高僑的課程都有做課後的輔導，老師會開放課後輔導時間，由老師或是專業輔導老師親自輔導，輔導時間可以將學校的作業、講義拿出來完成，不會的問題都能立刻獲得解決。老師也會安排輔導考卷讓學生多加練習，熟練解題技巧以及複習段考範圍，透過課後輔導能有效提升學習成效！
        老師開放的輔導時間會盡量配合學生，讓每位學生都能參加。也歡迎帶著你的課本來高僑問問題，解決你所有的疑惑！
      </p>
    </section>
    <section>
      <h4>高僑全自編教材</h4>
      <p>
        高僑使用全自編的教材，由教師群共同編撰，並定期更新校正，給學生最新、最專業、最精準的學習教材。高僑教材精準掌握了私中入學測驗、國小、國中、高中各校段考以及國中教育會考等題目方向，讓學習事半功倍，永遠走在最前面！
      </p>
    </section>
    <section>
      <h4>課後錄影補課</h4>
      <p>
        高僑使用優質的自動攝錄配備，將老師說的每句話、寫下的每個筆記都記錄下來，讓無法親自到場的你也能享受到和在教室上課一樣的高品質。
      </p>
    </section>
    <section>
      <h4>提供優質讀書環境</h4>
      <p>
        高僑提供學生最優質的讀書空間，下課後和同學們一起來高僑念書，一旁就有老師能解決問題，讓你在學習上無憂也無慮！
      </p>
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
section {
  margin: 30px auto;
  max-width: 800px;

  h4 {
    font-size: 18px;
    font-weight: bold;
    color: #1c2e53;
    position: relative;
    &:before {
      content: "";
      display: block;
      background-color: #e06960;
      width: 9px;
      height: 9px;
      border-radius: 100%;
      position: absolute;
      top: calc(50% - 4.5px);
      left: -16px;
    }
  }

  p {
    font-size: 14px;
    font-weight: bold;
    color: #565656;
    line-height: 1.5rem;
  }
}

@media (max-width: 1023px) {
  section {
    margin: auto 10px auto 30px;

    h4:before {
      background: url("../assets/joined-school-list-blue.svg") no-repeat !important;
      width: 15px !important;
      height: 15px !important;
    }

    &:nth-child(even) {
      h4:before {
        background-image: url("../assets/joined-school-list-yellow.svg") !important;
      }
    }
  }
}
</style>
